import { render, staticRenderFns } from "./InvoiceTypeSh.vue?vue&type=template&id=f52a6fa8"
import script from "./InvoiceTypeSh.vue?vue&type=script&lang=js"
export * from "./InvoiceTypeSh.vue?vue&type=script&lang=js"
import style0 from "./InvoiceTypeSh.vue?vue&type=style&index=0&id=f52a6fa8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports